import React, { useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import { SignInComponent } from 'components/Auth'

import { getSystemLng } from 'stores/Account/Select'

import AuthActions from '@enlyt/stores/Auth/Actions'
import LinkActions from 'stores/Links/Actions'
import { useAuth0 } from '@auth0/auth0-react'

export const SignInContainer = () => {
  const dispatch = useDispatch()
  const systemLng = useSelector(getSystemLng)
  const { loginWithRedirect } = useAuth0()

  useEffect(() => {
    dispatch(LinkActions.getExternalLinks(systemLng))
  }, [dispatch, systemLng])

  const handleSignIn = () => {
    dispatch(AuthActions.signInCerner())
  }

  const router = useRouter()
  const handleSignUp = useCallback(
    link => {
      router.push(link)
    },
    [router]
  )

  return (
    <SignInComponent
      onSubmit={handleSignIn}
      onSignUp={handleSignUp}
      loginWithRedirect={loginWithRedirect}
    />
  )
}
